import "./Header.css";
import React, { useState, useEffect } from "react";
import Modal from 'react-modal';
import NoticeBoard from "../NoticeBoard/NoticeBoard";
import { useMediaQuery } from "react-responsive";
Modal.setAppElement('#root');

const scrollTo = (ref) => {
  if (ref?.current) {
    ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else if (!ref) {
    window.location.href = '/';
  }
};

function Header(props) {
  const [scrolled, setScrolled] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: isMobile ? "397px" : "635px",
      height: isMobile ? "48rem" : '',
      zIndex: 10000
    },
  };
  let subtitle;
  const [showNoticeBoard, setShowNoticeBoard] = useState(false);

  function afterOpenModal() {
    subtitle.style.color = '#f00';
  }

  function closeModal() {
    setShowNoticeBoard(false);
  }

  return (
    <div className={`header${scrolled ? ' scrolled' : ''}`}>
      <div className="col-2 logo" onClick={() => props.missionRef ? window.scrollTo({ top: 0, behavior: 'smooth' }) : window.location.href = '/'} style={{ cursor: 'pointer' }}>
        <img src={isMobile ? "assets/deeptrade_logo.png" : "assets/deeptrade_logo_white.svg"} alt="logo" />
      </div>
      <div className="col-10">
        <div className="menu">
          <div className="menu_item" onClick={() => scrollTo(props.missionRef)}>Mission</div>
          <div className="menu_item" onClick={() => scrollTo(props.whatRef)}>What We Do</div>
          <div className="menu_item" onClick={() => scrollTo(props.technologyRef)}>Technology</div>
          <div className="menu_item" onClick={() => scrollTo(props.solutionRef)}>Solution</div>
          <div className="menu_item" onClick={() => scrollTo(props.xpercentRef)}>Service</div>
          <div className="menu_item" onClick={() => setShowNoticeBoard(!showNoticeBoard)}>Notice</div>
          <div className="menu_item" onClick={() => scrollTo(props.newsRef)}>News</div>
          <div className="menu_item" onClick={() => window.open("https://blog.naver.com/deeptrade", "_blank", "noopener,noreferrer")}>Blog</div>
        </div>
      </div>
      <div>
        <input id="toggle" type="checkbox" />
        <label className="toggle-container" htmlFor="toggle">
          <span className="button button-toggle"></span>
        </label>
        <nav className="nav">
          <div className="nav-item" onClick={() => scrollTo(props.whatRef)}>What We Do</div>
          <div className="nav-item" onClick={() => scrollTo(props.missionRef)}>Mission</div>
          <div className="nav-item" onClick={() => scrollTo(props.technologyRef)}>Technology</div>
          <div className="nav-item" onClick={() => scrollTo(props.solutionRef)}>Solution</div>
          <div className="nav-item" onClick={() => scrollTo(props.xpercentRef)}>Service</div>
          <div className="nav-item" onClick={() => setShowNoticeBoard(!showNoticeBoard)}>Notice</div>
          <div className="nav-item" onClick={() => scrollTo(props.newsRef)}>News</div>
        </nav>
      </div>

      {showNoticeBoard && (
        <Modal
          isOpen={showNoticeBoard}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Notice Modal"
        >
          <NoticeBoard />
        </Modal>
      )}
    </div>
  );
}

export default Header;
